import styled from "styled-components";

export const HeaderIcon = ({ onClick, imageSrc }) => {
  return (
    <HeaderIconWrapper onClick={onClick}>
      <HeaderIconImage src={imageSrc} />
    </HeaderIconWrapper>
  );
};

const HeaderIconWrapper = styled.div`
  display: flex;
  width: 50px;
  height: 50px;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  border-radius: 50%;
  outline: none;
  &:hover {
    cursor: pointer;
  }
`;

const HeaderIconImage = styled.img`
  height: var(--18px);
  width: var(--18px);
  object-fit: contain;
`;
